<template>
	<div class="item">
		<a class="link" :class="{visited}" @click="active = true">
			<div class="header">
				<div class="title" :class="{visited}" v-text="title"/>
				<div class="date">{{date}}</div>
			</div>

			<div class="sub" v-text="subtitle"/>
		</a>

		<modal v-if="active" v-bind="{slug}" @close="active = false"/>
	</div>
</template>

<script>
import {date} from "@/modules/utils";
import modal from "../item-modal.vue";

export default {
	components: {modal},
	props: {
		slug: {type: String, required: true},
		title: {type: String, required: true},
		visited: {type: Boolean, required: true},
		subtitle: {type: String, required: true},
		published_at: {type: Number, required: true}
	},
	data() {
		return {
			active: false
		}
	},
	computed: {
		date: (t) => `— ${date(t.published_at).string}`
	}
};
</script>

<style lang="scss" scoped>
.item {
	border-top: 1px solid #E2E2E2;

	.link {
		display: block;
		padding: 36px;
		@include res(mobile) {
			padding: 30px;
		}

		&.visited {
			opacity: 0.4;
		}
	}

	&:last-child {
		border-bottom: 1px solid #E2E2E2;
	}

	.header {
		display: flex;
		align-items: center;
		margin-bottom: 20px;

		@include res(mobile) {
			flex-direction: column;
			align-items: flex-start;
		}

		.title {
			font-size: 16px;
			font-weight: 700;

			@include res(mobile) {
				font-size: 15px;
			}

			&.visited {
				font-weight: 300;
			}
		}
		.date {
			font-size: 16px;
			font-weight: 300;
			margin-left: 5px;

			@include res(mobile) {
				font-size: 13px;
				color: #B1B1B1;
				margin-left: 0;
				margin-top: 10px;
			}
		}
	}

	.sub {
		font-size: 14px;
		font-weight: 300;
		line-height: 19px;
	}
}
</style>
